import React from 'react';
import { Button } from 'react-bootstrap'
import * as Index from '../../index'

export function BlackFriday(){

    const handleClick = () => {
      Index.blackFriday()
    }

    return (
        <div 
          className='black-friday sale w-100 card container shadow p-5 my-4 ratio ratio-4x3' 
          style={{'--bs-aspect-ratio': '72%'}}
          onClick={handleClick}
          >
          <div className='copy text-center h-100' style={{paddingTop:'38%'}}>
            <div className='display-4'><strong>Save $60.00!</strong></div>
            <div className='mx-auto d-inline-block'>
              <Button className='px-4' variant='danger'><strong>Shop Now</strong></Button>
            </div>
            <div className=''>Get one before your favorite color is gone!</div>
            <div className='text-muted'><small>* Sale ends cyber-Monday or when out of stock.</small></div>
          </div>
        </div>
    )
}